export default function useAppLink(campaign: string, vertical?: string): Ref<string> {
  const { $cookie } = useNuxtApp()
  const { siteUrl } = useRuntimeConfig().public
  const link = ref(
    `${siteUrl}/app${vertical === 'esim' ? '/esim' : ''}/?pid=Web&c=${campaign}&af_channel=Web`,
  )
  onMounted(() => {
    link.value += `&deep_link_sub1=${$cookie.value.getId()}`
  })
  return link
}
